import _createForOfIteratorHelper from "/Users/marklesbirel/Documents/GitHub/ManualProWeb/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import first from '@ckeditor/ckeditor5-utils/src/first';
/**
 * @module image/imagestyle/converters
 */

/**
 * Returns a converter for the `imageStyle` attribute. It can be used for adding, changing and removing the attribute.
 *
 * @param {Object} styles An object containing available styles. See {@link module:image/imagestyle/imagestyleediting~ImageStyleFormat}
 * for more details.
 * @returns {Function} A model-to-view attribute converter.
 */

export function modelToViewStyleAttribute(styles) {
  return function (evt, data, conversionApi) {
    if (!conversionApi.consumable.consume(data.item, evt.name)) {
      return;
    } // Check if there is class name associated with given value.


    var newStyle = getStyleByName(data.attributeNewValue, styles);
    var oldStyle = getStyleByName(data.attributeOldValue, styles);
    var viewElement = conversionApi.mapper.toViewElement(data.item);
    var viewWriter = conversionApi.writer;

    if (oldStyle) {
      viewWriter.removeClass(oldStyle.className, viewElement);
    }

    if (newStyle) {
      viewWriter.addClass(newStyle.className, viewElement);
    }
  };
}
/**
 * Returns a view-to-model converter converting image CSS classes to a proper value in the model.
 *
 * @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} styles The styles for which the converter is created.
 * @returns {Function} A view-to-model converter.
 */

export function viewToModelStyleAttribute(styles) {
  // Convert only non–default styles.
  var filteredStyles = styles.filter(function (style) {
    return !style.isDefault;
  });
  return function (evt, data, conversionApi) {
    if (!data.modelRange) {
      return;
    }

    var viewFigureElement = data.viewItem;
    var modelImageElement = first(data.modelRange.getItems()); // Check if `imageStyle` attribute is allowed for current element.

    if (!conversionApi.schema.checkAttribute(modelImageElement, 'imageStyle')) {
      return;
    } // Convert style one by one.


    var _iterator = _createForOfIteratorHelper(filteredStyles),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var style = _step.value;

        // Try to consume class corresponding with style.
        if (conversionApi.consumable.consume(viewFigureElement, {
          classes: style.className
        })) {
          // And convert this style to model attribute.
          conversionApi.writer.setAttribute('imageStyle', style.name, modelImageElement);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
} // Returns the style with a given `name` from an array of styles.
//
// @param {String} name
// @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat> } styles
// @returns {module:image/imagestyle/imagestyleediting~ImageStyleFormat|undefined}

function getStyleByName(name, styles) {
  var _iterator2 = _createForOfIteratorHelper(styles),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var style = _step2.value;

      if (style.name === name) {
        return style;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}